import { FormTabs } from "../../../Global/FormTabs";
import React from "react";
import Style from "../AddOrder/addOrder.module.scss";
import useAddOldCertificate from "./useAddOldCertificate";

const AddOldCertificate = ({ refetch }) => {
  const { tabs, activeTab, formik, renderTabContent, handleTabClick } =
    useAddOldCertificate({ refetch });
  return (
    <div>
      <FormTabs
        propStyle={{ root: Style.root }}
        tabs={tabs}
        active={activeTab}
        handleClick={handleTabClick}
      />
      <form onSubmit={formik.handleSubmit}>{renderTabContent()}</form>
    </div>
  );
};

export default AddOldCertificate;
